// src/pages/Tenants.jsx
import ComingSoon from '../components/ComingSoon';

const Tenants = () => {
  return <ComingSoon pageName="Tenants Portal" />;
};
export default Tenants;